import * as types from "./types";

const mutations = {
    [types.LOADING_DISTRIBUTION_VEHICLE](state, value) {
        state.loading = value;
    },
    [types.GET_DISTRIBUTION_VEHICLE_LIST](state, vehicles) {
        state.vehicles = vehicles;
    },
    [types.REMOVE_DISTRIBUTION_VEHICLE](state, id) {        
        state.vehicles = states.vehicle.filter((x) => x.id !== id);        
    },
    [types.ADD_DISTRIBUTION_VEHICLE](state, vehicles) {        
        state.vehicles.unshift(vehicles);
    },
    [types.UPDATE_DISTRIBUTION_VEHICLE](state, vehicles) {        
        const vehiclesIndex = state.vehicles.findIndex((x) => x.id === vehicles.id);
        state.vehicles[vehiclesIndex] = vehicles;        
    },
    [types.GET_DISTRIBUTION_VEHICLEBYID](state, vehicleId) {
        state.vehicleId = vehicleId;
    }
};

export default mutations;